function getPopupOptionsString(popupWidth, popupHeight) {
    var left = (document.body.clientWidth - popupWidth) * 0.5;
	var top = (document.body.clientHeight - popupHeight) * 0.5;
    return 'width=' + popupWidth + ',height=' + popupHeight + ',top=' + top + ',left=' + left;
};

function encodeString(string) {
    return window.encodeURIComponent(string);
};

function isiOSDevice() {
    return /iPad|iPhone|iPod/.test(window.navigator.userAgent) && !window.MSStream;
}

function isMobileDevice() {
    return /iPad|iPhone|iPod|Android/.test(window.navigator.userAgent) && !window.MSStream;
}

/**
 * Opens up a Facebook share popup with a URL.
 * @param url String - The URL to share by Facebook.
 * @param popupWidth - Integer The width of the share popup that will be opened.
 * @param popupHeight - Integer The height of the share popup that will be opened.
 */
module.exports.shareURLByFacebook = function(url, popupWidth, popHeight) {
    var sharerURL = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeString(url);
    window.open(sharerURL, 'facebook', getPopupOptionsString(popupWidth, popHeight));
};

/**
 * Opens up a Google Plus share popup with a URL.
 * @param url String - The URL to share by Facebook.
 * @param popupWidth - Integer The width of the share popup that will be opened.
 * @param popupHeight - Integer The height of the share popup that will be opened.
 * @param languageCode String - the language in which to display the dialog box (e.g. 'en', 'de', etc.)
 */
module.exports.shareURLByGooglePlus = function(url, popupWidth, popHeight, languageCode) {
    var sharerURL = 'https://plus.google.com/share?url=' + encodeString(url) + '&hl=' + languageCode;
    window.open(sharerURL, 'google', getPopupOptionsString(popupWidth, popHeight));
};



/**
 * Opens up a Twitter share popup with text.
 * @param text String - The text to share by Twitter.
 * @param popupWidth Integer - The width of the share popup that will be opened.
 * @param popupHeight Integer - The height of the share popup that will be opened.
 */
module.exports.shareByTwitter = function(text, popupWidth, popHeight) {
    var sharerUrl = 'https://twitter.com/intent/tweet?text=' + encodeString(text);
    window.open(sharerUrl, 'twitter', getPopupOptionsString(popupWidth, popHeight));
};

/**
 * Opens up an email client to send an email with a subject and body.
 * @param emailSubject String - The email's subject.
 * @param text String - The email's body.
 */
module.exports.shareByEmail = function(emailSubject, text) {
    window.location.href = 'mailto:?to=&subject=' + encodeString(emailSubject) + '&body=' + encodeString(text);
};

/**
 * Opens up an SMS client to send a message with text.
 * Works only on a mobile device.
 * @param text String - The text to share by SMS.
 */
module.exports.shareBySMS = function(text) {
    // SMS URL scheme is different for iOS, hence the condition.
    if (isiOSDevice()) {
        window.location.href = 'sms:&body=' + encodeString(text);
    } else {
        window.location.href = 'sms:?body=' + encodeString(text);
    }
};

/**
 * Opens up a WhatsApp client (if installed) to send a message with text.
 * Works only on a mobile device.
 * @param text String - The text to share by WhatsApp.
 * @param nativeApp [boolean] - Whether to launch the native app or use the web experience.
 *                              Defaults to true on mobile, false otherwise.
 */
module.exports.shareByWhatsApp = function(text, nativeApp) {
    if (nativeApp == null) {
      nativeApp = isMobileDevice()
    }
    if (nativeApp) {
        window.location.href = 'whatsapp://send?text=' + encodeString(text);
    } else {
        window.open('https://web.whatsapp.com/send?text=' + text);
    }
};

/**
 * Opens up a Messenger client (if installed) to send a link.
 * @param url String - The URL to share by Messenger.
 * @param appId Number - App ID required by Facebook.
 * @param nativeApp [boolean] - Whether to launch the native app or use the web experience.
 *                              Defaults to true if on mobile, false otherwise.
 */
module.exports.shareURLByMessenger = function(url, appId, redirectUri, nativeApp) {
    if (nativeApp == null) {
      nativeApp = isMobileDevice()
    }
    if (nativeApp) {
        window.location.href = 'fb-messenger://share?link=' + encodeURIComponent(url) + '&app_id=' + encodeURIComponent(appId);
    } else {
        window.open('http://www.facebook.com/dialog/send?app_id=' + appId + '&link=' +
        encodeURIComponent(url) + '&redirect_uri=' + encodeURIComponent(redirectUri));
    }
};
